import React from 'react';
import { Container } from 'react-bootstrap';

const Terms = () => {
    return (
        <>
            <div className='terms-page' style={{ padding: '100px 0', minHeight: '80vh' }}>
                <Container>
                    <div className='terms-content'>
                        <h1>Terms & Conditions</h1>
                        <div style={{ marginTop: '30px' }}>
                            <p>
                                Please read these terms and conditions carefully before using Our Service.
                            </p>
                            
                            <h2 style={{ marginTop: '30px' }}>Interpretation and Definitions</h2>
                            <p>
                                For the purposes of these Terms and Conditions:
                            </p>
                            <ul>
                                <li><strong>Company</strong> (referred to as either "the Company", "We", "Us" or "Our" in these Terms and Conditions) refers to S3 Infosoft, Specialty Business Center, Balewadi, Pune, Maharashtra 411045, India.</li>
                                <li><strong>Service</strong> refers to the Website and our cybersecurity services.</li>
                                <li><strong>Terms and Conditions</strong> (also referred to as "Terms") means these Terms and Conditions, which govern Your access to and use of the Service.</li>
                                <li><strong>Website</strong> refers to S3 Infosoft, accessible from our website.</li>
                                <li><strong>You</strong> means the individual accessing or using the Service, or the company, or other legal entity on behalf of which such individual is accessing or using the Service, as applicable.</li>
                            </ul>

                            <h2 style={{ marginTop: '30px' }}>Acknowledgment</h2>
                            <p>
                                These are the Terms and Conditions governing the use of this Service and the agreement between You and the Company. These Terms and Conditions set out the rights and obligations of all users regarding the use of the Service.
                            </p>
                            <p>
                                Your access to and use of the Service is conditioned on Your acceptance of and compliance with these Terms and Conditions. These Terms and Conditions apply to all visitors, users and others who access or use the Service.
                            </p>
                            <p>
                                By accessing or using the Service You agree to be bound by these Terms and Conditions. If You disagree with any part of these Terms and Conditions then You may not access the Service.
                            </p>

                            <h2 style={{ marginTop: '30px' }}>Links to Other Websites</h2>
                            <p>
                                Our Service may contain links to third-party websites or services that are not owned or controlled by the Company. We strongly advise You to read the terms and conditions and privacy policies of any third-party websites or services that You visit.
                            </p>

                            <h2 style={{ marginTop: '30px' }}>Termination</h2>
                            <p>
                                We may terminate or suspend Your access immediately, without prior notice or liability, for any reason whatsoever, including without limitation if You breach these Terms and Conditions.
                            </p>

                            <h2 style={{ marginTop: '30px' }}>Limitation of Liability</h2>
                            <p>
                                Notwithstanding any damages that You might incur, the entire liability of the Company and any of its suppliers under any provision of these Terms and Your exclusive remedy for all of the foregoing shall be limited to the amount actually paid by You through the Service.
                            </p>

                            <h2 style={{ marginTop: '30px' }}>Governing Law</h2>
                            <p>
                                The laws of India, excluding its conflicts of law rules, shall govern these Terms and Your use of the Service. Your use of the Application may also be subject to other local, state, national, or international laws.
                            </p>

                            <h2 style={{ marginTop: '30px' }}>Changes to These Terms and Conditions</h2>
                            <p>
                                We reserve the right, at Our sole discretion, to modify or replace these Terms at any time. If a revision is material We will make reasonable efforts to provide at least 30 days' notice prior to any new terms taking effect. What constitutes a material change will be determined at Our sole discretion.
                            </p>
                            <p>
                                By continuing to access or use Our Service after those revisions become effective, You agree to be bound by the revised terms. If You do not agree to the new terms, in whole or in part, please stop using the Service.
                            </p>

                            <h2 style={{ marginTop: '30px' }}>Contact Us</h2>
                            <p>
                                If you have any questions about these Terms and Conditions, You can contact us at:
                            </p>
                            <p>
                                Specialty Business Center, Balewadi, Pune, Maharashtra 411045, India
                            </p>
                        </div>
                    </div>
                </Container>
            </div>
        </>
    )
}

export default Terms;
